import { render, staticRenderFns } from "./ManageNews.vue?vue&type=template&id=6b120fc6&"
import script from "./ManageNews.vue?vue&type=script&lang=js&"
export * from "./ManageNews.vue?vue&type=script&lang=js&"
import style0 from "./ManageNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports